<template>
    <div>
        <div
            class="innerBox"
            style="
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 7.5px 10px;
                font-family: proxima-nova, sans-serif;
            "
        >
            <button
                class="btn"
                style="
                    font-size: 16px;
                    color: #6c6c6c;
                    font-weight: bold;
                    padding: 4px;
                    font-family: proxima-nova, sans-serif;
                "
                @click="$router.go(-1)"
            >
                <i class="fas fa-angle-left mr-2"></i>Back
            </button>
            <p
                class="mb-0"
                style="
                    font-size: 16px;
                    color: #b9b9b9;
                    font-weight: 600;
                    font-family: proxima-nova, sans-serif;
                "
            >
                | Driver List >> See Details <i class="fas fa-angle-right"></i>
            </p>
            <p
                class="mb-0 ml-1"
                style="
                    font-size: 16px;
                    color: #4b4b4b;
                    font-weight: bold;
                    font-family: proxima-nova, sans-serif;
                "
            >
                {{ driverDetail.name }}
            </p>
        </div>

        <div class="innerBox mt-4">
            <div
                class="div"
                style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    font-family: proxima-nova, sans-serif;
                "
            >
                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label
                            style="
                                color: #bcbcbc;
                                font-size: 20px;
                                font-family: proxima-nova, sans-serif;
                            "
                            >Nama</label
                        >
                    </div>
                    <div>
                        <label>
                            <label
                                style="
                                    color: #000000;
                                    font-size: 20px;
                                    font-family: proxima-nova, sans-serif;
                                "
                                >{{ driverDetail.name }}</label
                            >
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label
                            style="
                                color: #bcbcbc;
                                font-size: 20px;
                                font-family: proxima-nova, sans-serif;
                            "
                            >Ekspedisi</label
                        >
                    </div>
                    <div>
                        <label>
                            <label
                                style="
                                    color: #000000;
                                    font-size: 20px;
                                    font-family: proxima-nova, sans-serif;
                                "
                                >{{ driverDetail.ekspedisi }}</label
                            >
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label
                            style="
                                color: #bcbcbc;
                                font-size: 20px;
                                font-family: proxima-nova, sans-serif;
                            "
                            >User Login</label
                        >
                    </div>
                    <div>
                        <label>
                            <label
                                style="
                                    color: #000000;
                                    font-size: 20px;
                                    font-family: proxima-nova, sans-serif;
                                "
                                >{{ driverDetail.kode_ekspedisi }}</label
                            >
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label
                            style="
                                color: #bcbcbc;
                                font-size: 20px;
                                font-family: proxima-nova, sans-serif;
                            "
                            >Nomor HP</label
                        >
                    </div>
                    <div>
                        <label>
                            <label
                                style="
                                    color: #000000;
                                    font-size: 20px;
                                    font-family: proxima-nova, sans-serif;
                                "
                                >{{ driverDetail.phone }}</label
                            >
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="display: flex; flex-direction: column; flex: 1"
                >
                    <div>
                        <label
                            style="
                                color: #bcbcbc;
                                font-size: 20px;
                                font-family: proxima-nova, sans-serif;
                            "
                            >Status</label
                        >
                    </div>
                    <div>
                        <label>
                            <label
                                style="
                                    color: #000000;
                                    font-size: 20px;
                                    font-family: proxima-nova, sans-serif;
                                "
                                >{{ driverDetail.status }}</label
                            >
                        </label>
                    </div>
                </div>

                <div class="col mt-3 f-25">
                    <div class="row-3">
                        <!-- <label style="color: #BCBCBC; font-size: 20px;">Status Truck</label> -->
                    </div>
                    <div class="col-9">
                        <label>
                            <!-- <label style="color: #000000; font-size: 20px;">{{ driverDetail.status_truck }}</label> -->
                        </label>
                    </div>
                </div>
            </div>

            <div
                class="mt-5 ml-4 f-25"
                style="
                    display: flex;
                    flex-direction: column;
                    font-family: proxima-nova, sans-serif;
                "
            >
                <label
                    style="
                        color: #000000;
                        font-size: 17px;
                        font-family: proxima-nova, sans-serif;
                    "
                    >Detailed Information</label
                >
            </div>

            <div
                style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    font-family: proxima-nova, sans-serif;
                "
            >
                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="
                        display: flex;
                        flex-direction: column;
                        font-family: proxima-nova, sans-serif;
                    "
                >
                    <div>
                        <label
                            style="
                                color: #bcbcbc;
                                font-size: 17px;
                                font-family: proxima-nova, sans-serif;
                            "
                            >Email</label
                        >
                    </div>
                    <div>
                        <label
                            style="
                                color: #000000;
                                font-size: 17px;
                                font-family: proxima-nova, sans-serif;
                            "
                        >
                            <h5>{{ driverDetail.email }}</h5>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="
                        display: flex;
                        flex-direction: column;
                        font-family: proxima-nova, sans-serif;
                    "
                >
                    <div>
                        <label
                            style="
                                color: #bcbcbc;
                                font-size: 17px;
                                font-family: proxima-nova, sans-serif;
                            "
                            >No.KTP</label
                        >
                    </div>
                    <div>
                        <label
                            style="
                                color: #000000;
                                font-size: 17px;
                                font-family: proxima-nova, sans-serif;
                            "
                        >
                            <h5>{{ driverDetail.no_ktp }}</h5>
                        </label>
                    </div>
                </div>

                <div
                    class="mt-2 mr-4 ml-4 f-25"
                    style="
                        display: flex;
                        flex-direction: column;
                        font-family: proxima-nova, sans-serif;
                    "
                >
                    <div>
                        <label
                            style="
                                color: #bcbcbc;
                                font-size: 17px;
                                font-family: proxima-nova, sans-serif;
                            "
                            >No.SIM</label
                        >
                    </div>
                    <div>
                        <label
                            style="
                                color: #000000;
                                font-size: 17px;
                                font-family: proxima-nova, sans-serif;
                            "
                        >
                            {{ driverDetail.license_no }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Datepicker from "vue-datepicker";
import { BFormSelect } from "bootstrap-vue";

export default {
    metaInfo: {
        title: "Create Muatan",
    },
    data() {
        return {
            driverDetail: {},
            selectedDate: null,
            selectedSearchResult: null,
            searchQuery: "",
            searchResults: [{ value: "Pilih Nopol" }, { value: "Pilih Nopol" }],
        };
    },
    components: {
        Datepicker,
        BFormSelect,
    },
    mounted() {
        this.driverDetail = JSON.parse(this.$store.state.driverData);
        if (this.driverDetail == null) this.goBack();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
}

.chart {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
    align-items: center;
}

.elegant--sub-title {
    font-size: 18px;
    font-weight: 500;
    color: #4d4d4d;
}

/* .center {
          padding: 50px 20px;
          display: flexbox;
          flex-direction: column;
          align-items: center;
          justify-content: center;
      } */

.stats--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.table td,
.table th {
    text-align: center;
}

.news-image-1 img {
    max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
    text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
    text-align: left; /* To position the news-content on the bottom right */
}

.search-container {
    display: flex;
    align-items: center;
}

.dropdown-container {
    flex: 1;
    margin-right: 10px;
}

.searchbar-container {
    flex: 2;
}

.dropdown {
    width: 100%;
}

.searchbar {
    width: 50%;
    padding: 5px;
}
</style>
